export default __webpack_public_path__ + "static/pattern-column-title-and-content-08bd6ed7fb1322d3a1272aa012a7cfbe.svg";